import * as React from "react";
import { useCallback } from "react";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import { packsTableElements } from "illuminate/components/content-hub/packs-list/constants";
import { columnRenderers } from "illuminate/components/content-hub/packs-list/column-renderers";
import useTableElements from "illuminate/components/content-hub/packs-list/use-table-elements";
import { packEntitiesKeyFn, fetchThreatWidgetLatestPack } from "illuminate/hooks/api/packs";
import useSendPacksListTelemetry from "illuminate/hooks/useSendPacksListTelemetry";
const defaultTableLayout = {
  ...packsTableElements.defaultLayout,
  entityTableId: "TCW_PACKS_TABLE"
};
const IlluminatePacksList = () => {
  const sendTelemetry = useSendPacksListTelemetry();
  const { bulkSelection, expandedSections, entityActions } = useTableElements(true);
  const handleFetchPacks = useCallback(
    async (tableParams) => {
      const searchParams = {
        ...tableParams
      };
      const deserializedResponse = await fetchThreatWidgetLatestPack({ ...searchParams, tag: "attack" });
      if (searchParams.query) {
        sendTelemetry(searchParams, deserializedResponse);
      }
      return Promise.resolve(deserializedResponse);
    },
    [sendTelemetry]
  );
  return /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "packs list",
      entityActions,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "pack" }),
      tableLayout: defaultTableLayout,
      fetchEntities: handleFetchPacks,
      keyFn: packEntitiesKeyFn,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      bulkSelection,
      expandedSectionRenderers: expandedSections
    }
  );
};
export default IlluminatePacksList;
